<template>
  <div class="relative w-full mx-auto bg-EXPONDO-grey-5 group">
    <a
      :href="link"
      :aria-label="header"
      class="absolute w-full h-full"
    />
    <div class="flex p-4 gap-2 lg:gap-10">
      <div class="flex flex-col justify-between gap-5 w-1/2">
        <div class="flex flex-col gap-5">
          <h2 class="text-EXPONDO-black text-2xl font-bold">
            {{ header }}
          </h2>
          <p class="text-EXPONDO-black">
            {{ description }}
          </p>
        </div>
        <div
          class="bg-EXPONDO-primary text-EXPONDO-white font-semibold p-3 rounded flex justify-center text-center
          group-hover:bg-EXPONDO-primary-80 transition-colors"
        >
          {{ buttonText }}
        </div>
      </div>
      <ImgView
        :src="image"
        img-classes="object-contain h-[229px] w-1/2"
        :alt="alt"
      />
    </div>
  </div>
</template>
<script lang="ts">

export default defineComponent({
  name: 'CategoryBox',

  props: {
    link: {
      type: String,
      required: true,
    },
    header: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    buttonText: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      required: true,
    },
  },
});

</script>
